// API端点
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh",
  },
  USERS: {
    LIST: "/users",
    CREATE: "/users",
    UPDATE: (id) => `/users/${id}`,
    DELETE: (id) => `/users/${id}`,
  },
  TOKENS: {
    LIST: "/tokens",
    CREATE: "/tokens",
    UPDATE: (id) => `/tokens/${id}`,
    DELETE: (id) => `/tokens/${id}`,
  },
  TRADE_DATA: {
    LIST: "/trade-data",
    CREATE: "/trade-data",
    UPLOAD: "/trade-data/upload",
  },
  REPORTS: {
    GENERATE: "/reports/generate",
    DOWNLOAD: "/reports/download",
  },
  DASHBOARD: {
    OVERVIEW: "/dashboard/overview",
    STATS: "/dashboard/stats",
  },
};

// 用户角色
export const USER_ROLES = {
  ADMIN: "admin",
  USER: "user",
};

// 数据状态
export const DATA_STATUS = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
  IDLE: "idle",
};

// 交易所列表（默认值，实际应从 API 获取）
// 使用 useExchanges hook 获取最新的交易所列表
export const EXCHANGES = [
  "binance",
  "okex",
  "huobi",
  "bitget",
  "bybit",
  "kucoin",
  "gate",
  "mexc",
];

// 默认交易所名称映射（fallback）
// 实际应使用 useExchanges hook 和 getExchangeName 函数
export const EXCHANGE_NAMES = {
  binance: "Binance",
  okex: "OKX",
  huobi: "Huobi",
  bitget: "Bitget",
  bybit: "Bybit",
  kucoin: "KuCoin",
  gate: "Gate.io",
  mexc: "MEXC",
};

// 时间范围选项
export const TIME_RANGES = {
  TODAY: "today",
  YESTERDAY: "yesterday",
  LAST_7_DAYS: "last_7_days",
  LAST_30_DAYS: "last_30_days",
  LAST_90_DAYS: "last_90_days",
  CUSTOM: "custom",
};

// 图表类型
export const CHART_TYPES = {
  LINE: "line",
  BAR: "bar",
  PIE: "pie",
  AREA: "area",
};

// 交易类型
export const TRADE_TYPES = {
  SPOT: "spot",
  SWAP: "swap",
};

export const TRADE_TYPE_LABELS = {
  spot: "现货",
  swap: "合约",
};

export const TRADE_TYPE_COLORS = {
  spot: "green",
  swap: "blue",
};

export default {
  API_ENDPOINTS,
  USER_ROLES,
  DATA_STATUS,
  EXCHANGES,
  TIME_RANGES,
  CHART_TYPES,
  TRADE_TYPES,
  TRADE_TYPE_LABELS,
  TRADE_TYPE_COLORS,
};
